import React, { Component } from "react";

import { getBillById } from "./data";
import PageHead from "../../components/PageHead";
import "../../styles/features/DocumentsFilters/Filters.css";
import { FaClipboardList } from "react-icons/fa";
import { FaFileAlt } from "react-icons/fa";
import { MdAccountBalance } from "react-icons/md";
import { MdGroup } from "react-icons/md";
import { Wrapper, Tab, TabList, TabPanel } from "react-aria-tabpanel";
import Spinner from "../../containers/Spinner";
import Details from "./Tabs/Detaje/index";
import Dokumenta from "./Tabs/Dokumenta/index";
import Komisione from "./Tabs/Komisione/index";

class Filters extends Component {
  componentWillMount = async () => {
    let bill = await getBillById(this.props.match.params.id);
    this.setState({ bill });
  };
  state = {};

  render() {
    if (!this.state.bill) {
      return <Spinner />;
    }
    const bill = this.state.bill[0];
    return (
      <div>
        <PageHead font={"1.125rem"} text={bill.Titulli} />
        <div className="akte-tabs-wrapper">
          <Wrapper letterNavigation={true}>
            <TabList>
              <ul className="FancyTabs-tablist">
                <li className="FancyTabs-tablistItem">
                  <Tab id="t1" className="FancyTabs-tab">
                    {demoTab.bind(
                      null,
                      <div>
                        <FaClipboardList />
                        <span className="FancyTabs-tabText">Detaje</span>
                      </div>
                    )}
                  </Tab>
                </li>
                <li className="FancyTabs-tablistItem">
                  <Tab id="t2" className="FancyTabs-tab">
                    {demoTab.bind(
                      null,
                      <div>
                        <FaFileAlt />
                        <span className="FancyTabs-tabText">Dokumenta</span>
                      </div>
                    )}
                  </Tab>
                </li>
                <li className="FancyTabs-tablistItem">
                  <Tab id="t3" className="FancyTabs-tab">
                    {demoTab.bind(
                      null,
                      <div>
                        <MdAccountBalance />
                        <span className="FancyTabs-tabText">Amendamente</span>
                      </div>
                    )}
                  </Tab>
                </li>
                <li className="FancyTabs-tablistItem">
                  <Tab id="t4" className="FancyTabs-tab">
                    {demoTab.bind(
                      null,
                      <div>
                        <MdGroup size={20} />
                        <span className="FancyTabs-tabText">Komisione</span>
                      </div>
                    )}
                  </Tab>
                </li>
              </ul>
            </TabList>
            <div className="FancyTabs-panel">
              <TabPanel tabId="t1">
                <Details bill={bill} />
              </TabPanel>
              <TabPanel tabId="t2">
                <Dokumenta
                  dokumenta={bill.Dokumentat.filter(element => {
                    let bool = true;
                    if (element.TipDok.Emri === "Amendamente") {
                      bool = false;
                    }
                    return bool;
                  })}
                />
              </TabPanel>
              <TabPanel tabId="t3">
                <Dokumenta
                  dokumenta={bill.Dokumentat.filter(element => {
                    let bool = true;
                    if (element.TipDok.Emri !== "Amendamente") {
                      bool = false;
                    }
                    return bool;
                  })}
                />
              </TabPanel>
              <TabPanel tabId="t4">
                <Komisione bill={bill} />
              </TabPanel>
            </div>
          </Wrapper>
        </div>
      </div>
    );
  }
}
function demoTab(content, tabState) {
  let cl = "FancyTabs-tabInner";
  if (tabState.isActive) cl += " is-active";
  return <div className={cl}>{content}</div>;
}

export default Filters;
